// extracted by mini-css-extract-plugin
export default {"root":"breadCrumbs_root__T8Kcb","link":"breadCrumbs_link__KnX-d","activeLink":"breadCrumbs_activeLink__pD0X1"};